import { AssetClassificationStatus } from "../../models";
import { WriteOffLoanFields } from "./types";

export function assertWriteOffFieldsValid(fieldData: WriteOffLoanFields) {
  const { writeOffDate, reason } = fieldData;
  if (!writeOffDate) throw new Error("Enter write off date");
  if (!reason) throw new Error("Enter write off reason");
}

export const assetClassificationStatusToTagMap: Record<
  AssetClassificationStatus,
  { label: string; color: string }
> = {
  // STANDARD: { label: "Standard", color: "#008000" },
  SUB_STANDARD: { label: "Sub Standard", color: "#FFA500" },
  DOUBTFUL: { label: "Doubtful", color: "#FF4500" },
  LOSS: { label: "Loss", color: "#B22222" },
};
